module.exports = __webpack_public_path__ + "static/media/manman.229a56a4.png";